import monitorService from '@/services/monitor.service';
import { filterRulesMapped } from '@/tools/filterRules'
import { TRACK_DISORDER_HEADERS } from './constants';

export default {
    name: "TrackDisorderComponent",
    components: {},
    data() {
        return {
            tableDataKey: "idThing",
            tableHeaders: TRACK_DISORDER_HEADERS,
            tableFilterRules: {},
            tableData: [],
            loading: false,
        };
    },
    async mounted() {
        this.loading = true;
        try {
            const data = await monitorService.getTrackDisorder();
            this.tableData.cleanAndUpdate(data.data);
            this.setTableFilterRules();
        } finally {
            this.loading = false;
        }
    },
    beforeDestroy() {
    },
    methods: {
        async refreshTable() {
            this.loading = true;
            try {
                const data = await monitorService.getTrackDisorder();
                this.tableData.cleanAndUpdate(data.data);
                this.setTableFilterRules();
            } finally {
                this.loading = false;
            }

        },
        setTableFilterRules() {
            this.tableFilterRules = {}
            this.tableHeaders.forEach(header => {
                this.tableFilterRules[header.value] = filterRulesMapped[header.filterType]
            })
        },
    }
};
